<template>
  <v-snackbar style="text-align:center" :color="snackColor" :timeout="snackTimeout" top :value="snackbarValue" @change="$emit('update:snackbar', $event)">
    {{ snackMessage }}
    <v-btn dark flat @click.native.stop.prevent="$emit('update:snackbar', false)">{{ $t('Button.Close') }}</v-btn>
  </v-snackbar>
</template>

<script>
  export default {
    props: {
      snackbar: {
        type: Boolean,
        default: false,
      },
      snackColor: {
        type: String,
        default: '',
      },
      snackMessage: {
        type: String,
        default: '',
      },
      snackTimeout: {
        type: [Number, Object],
        default: () => null,
      },
    },
    data() {
      return {
        snackbarValue: false,
      }
    },
    watch: {
      snackbar() {
        this.snackbarValue = this.snackbar
      },
    },
    created() {
      this.snackbarValue = this.snackbar
    },
  }
</script>